import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Campaign } from '../models/campaign';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Paginator } from '../models/paginator';

@Injectable({
  providedIn: 'root'
})
export class CampaignService {

  constructor(
    private http: HttpClient
  ) {
  }

  create(campaign: Campaign) {
    return firstValueFrom(this.http
      .post<Campaign>(`${environment.backend}/campaigns`, campaign));
  }


  // exists(label: string) {
  //   return firstValueFrom(this.http
  //     .get<{ exists: boolean }>(`${environment.backend}/tags/exists/${label}`));
  // }

  // documentsCount(id: string) {
  //   return firstValueFrom(this.http
  //     .get<{ count: number }>(`${environment.backend}/tags/${id}/documents/count`));
  // }


  retrieveAll(pageNumber: number, limit: number, offset: number, query?: string): Promise<Paginator<Campaign>> {
    let params = new HttpParams()
      .set('page', pageNumber)
      .set('limit', limit)
      .set('offset', offset)


    if (query) {
      params = params.set('q', query);
    }

    return firstValueFrom(this.http
      .get<Paginator<Campaign>>(`${environment.backend}/campaigns/search`, { params }));
  }

  update(id: string, campaign: Campaign) {
    return firstValueFrom(this.http
      .put<Campaign>(`${environment.backend}/campaigns/${id}`, campaign));
  }

  delete(id: string) {
    return firstValueFrom(this.http
      .delete<void>(`${environment.backend}/campaigns/${id}`));
  }
}
